import(/* webpackMode: "eager" */ "/home/deployer/www/black-friday-norge.no/releases/20261023_105100/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/deployer/www/black-friday-norge.no/releases/20261023_105100/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/deployer/www/black-friday-norge.no/releases/20261023_105100/src/components/elements/ItemsListByTag/index.tsx");
